import { render, staticRenderFns } from "./StaffRanking.vue?vue&type=template&id=c30200e2&scoped=true"
import script from "./StaffRanking.vue?vue&type=script&lang=js"
export * from "./StaffRanking.vue?vue&type=script&lang=js"
import style0 from "./StaffRanking.scss?vue&type=style&index=0&id=c30200e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30200e2",
  null
  
)

export default component.exports